// src/routes/Routes.jsx
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from '../auth/ProtectedRoute';
import AppLayout from '../layouts/AppLayout';
import LandingPage from '../pages/LandingPage';
import HomePage from '../pages/HomePage';
import Dashboard from '../pages/Dashboard';
import CompanyDetail from '../pages/CompanyDetail';
import AdminOperations from '../components/AdminOperations';
import DataScrapeAdmin from '../components/DataScrapeAdmin';
import DocumentIngestionPage from '../pages/DocumentIngestionPage';
import NotesPage from '../pages/NotesPage';
import FundsPage from '../pages/FundsPage';
import PortfolioPage from '../pages/PortfolioPage';
import DashboardsPage from '../pages/DashboardsPage';
import HormuzWatchPage from '../pages/dashboards/HormuzWatchPage';
import DCTrackerPage from '../pages/dashboards/DCTrackerPage';
import BankLensPage from '../pages/dashboards/bankLens/BankLensPage';
import { isEntraConfigured } from '../auth/authConfig';

const AppRoutes = () => {
    // Check if Entra External ID is configured
    const useEntraAuth = isEntraConfigured();

    // If Entra is not configured, show setup message
    if (!useEntraAuth) {
        return (
            <div style={{
                padding: '40px',
                maxWidth: '600px',
                margin: '100px auto',
                textAlign: 'center',
                fontFamily: 'var(--font-sans)',
                color: 'var(--text-1)'
            }}>
                <h1>⚠️ Authentication Not Configured</h1>
                <p style={{ marginTop: '20px', fontSize: '16px', lineHeight: '1.6', color: 'var(--text-2)' }}>
                    Microsoft Entra External ID authentication is required but not configured.
                </p>
                <div style={{
                    marginTop: '30px',
                    padding: '20px',
                    backgroundColor: 'var(--card-bg)',
                    borderRadius: '8px',
                    textAlign: 'left',
                    border: '1px solid var(--border)'
                }}>
                    <h3>Setup Instructions:</h3>
                    <ol style={{ marginTop: '10px', paddingLeft: '20px' }}>
                        <li>Create Entra External ID tenant in Azure Portal</li>
                        <li>Register SPA and API applications</li>
                        <li>Create <code>.env.local</code> with:
                            <pre style={{
                                marginTop: '10px',
                                padding: '10px',
                                backgroundColor: 'var(--bg-3)',
                                borderRadius: '4px',
                                overflow: 'auto',
                                color: 'var(--text-2)'
                            }}>
                                {`REACT_APP_ENTRA_TENANT_ID=your-tenant-id
REACT_APP_ENTRA_TENANT_SUBDOMAIN=your-subdomain
REACT_APP_ENTRA_SPA_CLIENT_ID=your-spa-client-id
REACT_APP_ENTRA_API_CLIENT_ID=your-api-client-id`}
                            </pre>
                        </li>
                        <li>Restart the development server</li>
                    </ol>
                </div>
                <p style={{ marginTop: '20px', fontSize: '14px', color: 'var(--text-2)' }}>
                    See <strong>AUTH_README.md</strong> for detailed setup instructions.
                </p>
            </div>
        );
    }

    return (
        <Routes>
            {/* Public Routes */}
            <Route path="/" element={<LandingPage />} />

            {/* Protected Routes - Always require MSAL authentication */}
            <Route
                element={
                    <ProtectedRoute>
                        <AppLayout />
                    </ProtectedRoute>
                }
            >
                <Route path="/home" element={<HomePage />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/company/:id" element={<CompanyDetail />} />
                <Route path="/notes" element={<NotesPage />} />
                <Route path="/funds" element={<FundsPage />} />
                <Route path="/portfolio" element={<PortfolioPage />} />
                <Route path="/dashboards" element={<DashboardsPage />} />
                <Route path="/dashboards/hormuz" element={<HormuzWatchPage />} />
                <Route path="/dashboards/dc-tracker" element={<DCTrackerPage />} />
                <Route path="/dashboards/bank-lens" element={<BankLensPage />} />
                <Route path="/admin/operations" element={<AdminOperations />} />
                <Route path="/admin/data-scrape" element={<DataScrapeAdmin />} />
                <Route path="/admin/ingest" element={<DocumentIngestionPage />} />
            </Route>

            {/* Catch all - redirect to dashboard */}
            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    );
};

export default AppRoutes;
